import React from 'react'
import { Link } from 'gatsby'
import { Index } from 'elasticlunr'

export default ({ searchIndex }) => {
	const [userQuery, setUserQuery] = React.useState(``)
	const [results, setResults] = React.useState([])

	let index

	const getOrCreateIndex = () => (index ? index : Index.load(searchIndex))
	const search = event => {
		const query = event.target.value
		index = getOrCreateIndex()
		setUserQuery(query)
		setResults(
			index
				.search(query, { expand: true })
				.map(({ ref }) => index.documentStore.getDoc(ref))
		)
	}
	return (
		<div className="container popup-inner">
			<div className="row">
				<div className="col-sm-12">
					<form id="search-form">
						<div className="input-group">
							<input
								type="text"
								className="form-control"
								placeholder="Type to search"
								id="search-input"
								aria-label="Search"
								value={userQuery}
								onChange={search}
							/>
						</div>
					</form>
					<div id="search-results">
						{results.map(page => (
							<div className="result-item" key={page.id}>
								<Link to={page.slug}>
									<div className="title">{page.title}</div>
									<div className="date">{page.date}</div>
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
